import { cn } from '@quick/utils';
import { ReactComponent as MenuArrow } from '@quick/components/img/menu-arrow.svg';

export function MenuExpander({ onClick }: { onClick: () => void }) {
  return (
    <button
      className={cn(
        `bg-gray-light-2 absolute -right-3 top-28 z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-400 opacity-0 transition-transform dark:bg-gray-600`,
        `group-focus-within/menu:opacity-100 group-hover/menu:opacity-100 [&_>_svg]:fill-gray-800 [&_>_svg]:dark:fill-gray-400`,
        'group-data-[menu=closed]/menu:rotate-180 group-data-[menu=closed]/menu:transform'
      )}
      onClick={onClick}
      type="button"
    >
      <MenuArrow />
    </button>
  );
}
